import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/** @jsx jsx */

import React from 'react';
import { themed, useGlobalTheme } from '@atlaskit/theme/components';
import { borderRadius } from '@atlaskit/theme/constants';
import { R50, R500, R75, Y50, Y500, Y75, B50, B500, B75, G50, G500, G75, P50, P500, P75, N30A, N800, N40, DN60, DN70, DN800 } from '@atlaskit/theme/colors';
import { jsx } from '@emotion/react';
export var resolveColors = function resolveColors(color) {
  switch (color) {
    case 'red':
      {
        var colorArray = ["var(--ds-background-accent-red-subtlest, ".concat(R50, ")"), "var(--ds-text-accent-red, ".concat(R500, ")"), "var(--ds-background-accent-red-subtler, ".concat(R75, ")")];
        return {
          light: colorArray,
          dark: colorArray
        };
      }
    case 'yellow':
      {
        var _colorArray = ["var(--ds-background-accent-yellow-subtlest, ".concat(Y50, ")"), "var(--ds-text-accent-yellow, ".concat(Y500, ")"), "var(--ds-background-accent-yellow-subtler, ".concat(Y75, ")")];
        return {
          light: _colorArray,
          dark: _colorArray
        };
      }
    case 'blue':
      {
        var _colorArray2 = ["var(--ds-background-accent-blue-subtlest, ".concat(B50, ")"), "var(--ds-text-accent-blue, ".concat(B500, ")"), "var(--ds-background-accent-blue-subtler, ".concat(B75, ")")];
        return {
          light: _colorArray2,
          dark: _colorArray2
        };
      }
    case 'green':
      {
        var _colorArray3 = ["var(--ds-background-accent-green-subtlest, ".concat(G50, ")"), "var(--ds-text-accent-green, ".concat(G500, ")"), "var(--ds-background-accent-green-subtler, ".concat(G75, ")")];
        return {
          light: _colorArray3,
          dark: _colorArray3
        };
      }
    case 'purple':
      {
        var _colorArray4 = ["var(--ds-background-accent-purple-subtlest, ".concat(P50, ")"), "var(--ds-text-accent-purple, ".concat(P500, ")"), "var(--ds-background-accent-purple-subtler, ".concat(P75, ")")];
        return {
          light: _colorArray4,
          dark: _colorArray4
        };
      }
    case 'grey':
    default:
      return {
        light: ["var(--ds-background-neutral, ".concat(N30A, ")"), "var(--ds-text, ".concat(N800, ")"), "var(--ds-background-neutral-hovered, ".concat(N40, ")")],
        dark: ["var(--ds-background-neutral, ".concat(DN70, ")"), "var(--ds-text, ".concat(DN800, ")"), "var(--ds-background-neutral-hovered, ".concat(DN60, ")")]
      };
  }
};
export var DateLozenge = function DateLozenge(props) {
  var theme = useGlobalTheme();
  var colors = themed(resolveColors(props.color))({
    theme: theme
  });
  if (colors === '') {
    colors = ['', '', ''];
  }
  var _colors = colors,
    _colors2 = _slicedToArray(_colors, 3),
    background = _colors2[0],
    color = _colors2[1],
    hoverBackground = _colors2[2];
  return jsx("span", {
    css: {
      borderRadius: borderRadius(),
      padding: '2px 4px',
      margin: '0 1px',
      position: 'relative',
      transition: 'background 0.3s',
      whiteSpace: 'nowrap',
      cursor: props.onClick ? 'pointer' : 'unset',
      background: background,
      color: color,
      '&:hover': {
        background: hoverBackground
      }
    }
  }, props.children);
};